// src/components/Dashboard/MainOption.jsx

import React from "react";
import { Radio, RadioGroup, FormControlLabel, Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid"; // Ensure consistent import
import MainLabel from "./MainLabel";
import MainHeader from "./MainHeader";

const MainOption = ({
  title,
  icon,
  data,
  selectedValue,
  onChange,
  subtitle,
  helpText, // New prop for help tooltip
}) => {
  return (
    <Box>
      <MainHeader title={title} component={icon} helpText={helpText} />
      <RadioGroup
        value={selectedValue}
        onChange={onChange}
        row
      >
        <Grid container spacing={1} alignItems="center" sx={{ flexWrap: "nowrap" }}>
          {data.map((d) => (
            <Grid item key={`${d.value}-option`}>
              <FormControlLabel
                value={d.value}
                control={<Radio />}
                label={
                  <Typography sx={{ color: "grey.500" }}>
                    {d.value}
                  </Typography>
                }
              />
            </Grid>
          ))}
        </Grid>
      </RadioGroup>
      <MainLabel variant="caption" content={subtitle} />
    </Box>
  );
};

export default MainOption;
